module.exports = __webpack_public_path__ + "media/images/premium/premium-card-bg-9d2d2fa7a4144e26dc8199ddd7549910.png";